import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ArrayUtil } from '../../../../../common/utils/array.util';
import { OptionFee } from '../detail-fee/detail-fee';
import { DateUtil } from '../../../../../common/utils/date.util';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'overview-product',
    templateUrl: './overview-product.html',
    styleUrls: ['./overview-product.scss'],
})

export class OverviewProduct implements OnInit, OnChanges {
    @Input('product') product: any = {};
    approveDays: string = ' hàng tuần';
    public DAYS_OF_WEEK_WORKING_DAY = [1, 2, 3, 4, 5];
    public daysOfWeek: any[] = [];
    
    optionBuyFee: OptionFee = new OptionFee({
      valueTitle: 'Giá trị mua',
      valueUnit: '',
      feeTitle: 'Phí mua',
      feeUnit: '%',
    });
    optionSellFee: OptionFee = new OptionFee({
        valueTitle: 'Thời gian nắm giữ',
        valueUnit: 'tháng',
        feeTitle: 'Phí bán',
        feeUnit: '%',
    });
    constructor(
      public translateService: TranslateService,
    ) {
    }
    ngOnInit(): void {
      this.daysOfWeek = [
        {id: 1, code: "MONDAY", name: this.translateService.instant("Thứ hai")},
        {id: 2, code: "TUESDAY", name: this.translateService.instant("Thứ ba")},
        {id: 3, code: "WEDNESDAY", name: this.translateService.instant("Thứ tư")},
        {id: 4, code: "THURSDAY", name: this.translateService.instant("Thứ năm")},
        {id: 5, code: "FRIDAY", name: this.translateService.instant("Thứ sáu")},
        {id: 6, code: "SATURDAY", name: this.translateService.instant("Thứ bảy")},
        {id: 7, code: "SUNDAY", name: this.translateService.instant("Chủ nhật")}
      ];
      this.updateProduct();
    }
    ngOnChanges(simpleChanges: SimpleChanges): void {
      const changes: any = simpleChanges;
      if (changes.product && changes.product.currentValue) {
        this.updateProduct();
      }
    }
    updateProduct() {
      this.approveDays = this.product.code === 'TBLF' ? ': ' + this.translateService.instant('tuần thứ nhất và tuần thứ ba hàng tháng') : '';
      if (this.product.productTradingSession) {
        let closeBankNote = this.product.productTradingSession.closedBankNoteTimeString;
        closeBankNote = this.translateService.instant('Trước') + ' ' + closeBankNote.substring(0, 5) + ', ' + closeBankNote.substring(6, closeBankNote.length);
        this.product.productTradingSession.closedBankNoteString = closeBankNote;
        let closedOrderBookTimeString = this.product.productTradingSession.closedOrderBookTimeString;
        closedOrderBookTimeString =
          this.translateService.instant('Trước') + ' ' + 
          closedOrderBookTimeString.substring(0, 5) + ', ' +
          closedOrderBookTimeString.substring(6, closedOrderBookTimeString.length);
        this.product.productTradingSession.closedOrderBookString = closedOrderBookTimeString;
      }
        this.product.owner = this.product.owner || {};
        if (this.product.productBond && this.product.productBond.issuerInfo
          && this.product.productBond.issuerInfo.id) {
            this.product.owner = this.product.productBond.issuerInfo;
        }
        this.product.productAssetAllocationModelList = this.product.productAssetAllocationModelList || [];
        this.product.assets = this.product.productAssetAllocationModelList.map((ass: any) => this.translateService.instant(ass.name) ).join(", ");
        this.product.productFeeDiscountList = this.product.productFeeDiscountList || [];
        this.product.productFeeList = this.product.productFeeList || [];
        this.product.productFeeList.sort((a: any, b: any) => {
          if (a.beginVolume > b.beginVolume) {
              return 1;
          }
          if (a.beginVolume < b.beginVolume) {
              return -1;
          }
              return 0; 
        })
        this.product.feeBuys = [];
        this.product.normalTimeHolds = [];
        this.product.productFeeList.forEach((fee: any) => {
          if (fee.type === 'BUY') {
            this.product.feeBuys.push(fee);
          } else if (fee.type === 'SELL')  {
            this.product.normalTimeHolds.push(fee);
          }
        })
        this.product.website = this.product.website || '';
        if (this.product.website.substring(0, 4) !== 'https') {
          this.product.website = 'https://' + this.product.website;
        }
        
        this.product.productTransactionDateList = this.product.productTransactionDateList || [];
        if (ArrayUtil.arraysEqual(this.DAYS_OF_WEEK_WORKING_DAY, this.product.productTransactionDateList)) {
          this.product.transactionDate =`${this.translateService.instant("Thứ hai")} ${this.translateService.instant("đến")} ${this.translateService.instant("Thứ sáu")}`;
        } else if (this.product.productTransactionDateList.length > 0) {
          this.product.transactionDate = this.daysOfWeek
            .filter(day => this.product.productTransactionDateList.indexOf(day.id) > -1)
            .map(day => day.name)
            .join(', ');
        } else {
          this.product.transactionDate = '';
        }
        this.product.bank = this.product.bank || this.product.productSupervisoryBankAccount || {};
        if (this.product.fundReport) {
          this.product.fundReport.text = `${this.product.fundReport.totalAssetValueStr} (${this.translateService.instant('Theo báo cáo tháng')} ${DateUtil.parseDate(this.product.fundReport.reportTime, 'MM/yyyy')})`;
      }
    }
}
